export default __webpack_public_path__ + "static/media/question.ecc11708.webp";